import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failureaddQuestionType,
  successaddQuestionType,
} from "./AddQuestionTypeSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { IQuestionType } from "../../../Pages/QuestionType/IQuestionType";

import {
  failuredeleteQuestionType,
  successdeleteQuestionType,
} from "./DeleteQuestionTypeSlice";
import {
  failurelistQuestionType,
  successlistQuestionType,
} from "./ListQuestionTypeSlice";
import {
  failureEditQuestionType,
  successEditQuestionType,
} from "./EditQuestionTypeSlice";
import {
  failureGetQuestionSubType,
  successGetQuestionSubType,
} from "./GetQuestionSubType";
import { failureListSubject, successListSubject } from "./ListSubjectListSlice";
import {
  failurelistDashboardPerformenceTrend,
  successlistDashboardPerformenceTrend,
} from "./ListDashboardPerformanceTrend";
import {
  failureScheduleQuestionTypes,
  successScheduleQuestionTypes,
} from "./ScheduleQuestionTypesSlice";

// list
const ListQuestionTypeApi = () => {
  return api.get("/api/questionType/questionType");
};

export function* ListQuestionTypeCall() {
  try {
    const response: AxiosResponse = yield call(ListQuestionTypeApi);
    yield put(successlistQuestionType(response.data));
  } catch (error) {
    yield put(failurelistQuestionType(error));
  }
}

// list Trend
const ListDashboardPerformenceTrendApi = () => {
  return api.get("/api/dashboard/questiontype");
};

export function* ListDashboardPerformenceTrendCall() {
  try {
    const response: AxiosResponse = yield call(
      ListDashboardPerformenceTrendApi
    );
    yield put(successlistDashboardPerformenceTrend(response.data));
  } catch (error) {
    yield put(failurelistDashboardPerformenceTrend(error));
  }
}

const GetQuestionSubTypeApi = () => {
  return api.get("/api/questionType/list-subtype");
};

export function* GetQuestionSubTypeCall() {
  try {
    const response: AxiosResponse = yield call(GetQuestionSubTypeApi);
    yield put(successGetQuestionSubType(response.data));
  } catch (error) {
    yield put(failureGetQuestionSubType(error));
  }
}

const ListSubjectListApi = () => {
  return api.get("/api/questionType/subjectlist");
};

export function* ListSubjectListCall() {
  try {
    const response: AxiosResponse = yield call(ListSubjectListApi);
    yield put(successListSubject(response.data));
  } catch (error) {
    yield put(failureListSubject(error));
  }
}

// add
const AddQuestionTypeApi = (action: PayloadAction<IQuestionType>) => {
  const formData = new FormData();

  if (action.payload.image) formData.append("image", action.payload.image);
  if (action.payload.name) formData.append("name", action.payload.name);
  if (typeof action.payload.Status === "boolean")
    formData.append("Status", String(action.payload.Status));
  if (typeof action.payload.subject_id === "number")
    formData.append("subject_id", String(action.payload.subject_id));
  if (typeof action.payload.sequence === "number")
    formData.append("sequence", String(action.payload.sequence));
  if (action.payload.description)
    formData.append("description", action.payload.description);

  return api.post("/api/questionType/create-question", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export function* AddQuestionTypeCall(action: PayloadAction<IQuestionType>) {
  try {
    const response: AxiosResponse = yield call(AddQuestionTypeApi, action);
    yield put(successaddQuestionType(response.data));
  } catch (error) {
    yield put(failureaddQuestionType(error));
  }
}

// edit
const EditQuestionTypeApi = (action: PayloadAction<IQuestionType>) => {
  const formData = new FormData();

  if (typeof action.payload.id === "number")
    formData.append("id", String(action.payload.id));
  if (action.payload.image) formData.append("image", action.payload.image);
  if (action.payload.name) formData.append("name", action.payload.name);
  if (typeof action.payload.Status === "boolean")
    formData.append("Status", String(action.payload.Status));
  if (typeof action.payload.subject_id === "number")
    formData.append("subject_id", String(action.payload.subject_id));
  if (typeof action.payload.sequence === "number")
    formData.append("sequence", String(action.payload.sequence));
  if (action.payload.description)
    formData.append("description", action.payload.description);

  return api.put("/api/questionType/update/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export function* EditQuestionTypeCall(action: PayloadAction<IQuestionType>) {
  try {
    const response: AxiosResponse = yield call(EditQuestionTypeApi, action);
    yield put(successEditQuestionType(response.data));
  } catch (error) {
    yield put(failureEditQuestionType(error));
  }
}

// delete
const DeleteQuestionTypeApi = (action: PayloadAction<number>) => {
  return api.delete("/api/questionType/delete/", {
    params: { id: action.payload },
  });
};

export function* DeleteQuestionTypeCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteQuestionTypeApi, action);
    yield put(successdeleteQuestionType(response.data));
  } catch (error) {
    yield put(failuredeleteQuestionType(error));
  }
}

// schedule question types by subject ID
const ScheduleQuestionTypesApi = (subjectId: number) => {
  return api.get(`/api/schedule-class/question-types?subject_id=${subjectId}`);
};

export function* ScheduleQuestionTypesCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(ScheduleQuestionTypesApi, action.payload);
    yield put(successScheduleQuestionTypes(response.data));
  } catch (error) {
    yield put(failureScheduleQuestionTypes(error));
  }
}
